<template>
  <button
    v-if="!isLoading"
    type="button"
    class="basic-detail-button-style"
    :disabled="isButtonDisabled"
    @click.prevent="doAction"
  >
    {{ buttonName }}
  </button>
</template>
<script>
  import { showLoginPopup, showVoucherPopup } from '@/common/utils/scalable.player'
  import { actionButtonStateInfoData } from '@/common/utils/player.action.button'
  import { PATH_NAME_PLAYER_STREAM } from '@/common/resources/router.const'
  import { PlayerInterface } from '@/common/utils/player.interface'
  import cookie from '@/common/utils/cookie'

  const ACTION_STATE = {
    LOGIN: 'login',
    STREAM: 'stream',
    PURCHASE: 'purchase',
    NONE: 'none'
  }
  export default {
    name: 'PlayerActionButton',
    props: {
      contentInfo: {
        type: Object,
        default: () => ({})
      },
      landingInfo: {
        type: Object,
        default: () => ({})
      },
      contentType: { // vod/ movie/ qvod/ live
        type: String,
        default: ''
      }
    },
    data () {
      return {
        action: '',
        buttonName: '',
        isButtonDisabled: false,
        episodeNumber: '',
        isLoading: true,
        isWavveOn: cookie.isWavveOn()
      }
    },
    computed: {
      hasMovieMainFilm () {
        return Number(this.contentInfo?.countinfo?.typeM || '0') > 0
      },
      contentStatus () {
        return this.landingInfo.contents_status || ''
      }
    },
    methods: {
      doAction () {
        switch (this.action) {
          case ACTION_STATE.LOGIN :
            showLoginPopup()
              break
          case ACTION_STATE.STREAM:
            const query = this.$route.query

            if (this.contentType === 'vod') {
              const { content_id: contentId = '' } = this.landingInfo
              Object.assign(query, { contentid: contentId })
            }

            this.$router.push({
              name: PATH_NAME_PLAYER_STREAM,
              params: { section: this.contentType },
              query: query
            })
            break
          case ACTION_STATE.PURCHASE:
            try {
              PlayerInterface.pause()
            } catch (e) {}
            showVoucherPopup({ type: this.contentType, contentInfo: this.contentInfo })
            break
          case ACTION_STATE.NONE:
            break
        }
      },
      buttonDisplay (status) {
        let display = ''
        switch (status) {
          case 'commingsoon' :
            this.isButtonDisabled = true
            display = '공개 예정'
            break
          case 'closed' :
            this.isButtonDisabled = true
            display = '판매 종료'
            break
          case 'continue' :
            display = '이어보기'
            break
          case 'normal' :
            display = `에피소드 ${this.episodeNumber} 보기`
            break
          case 'latest' :
            display = `최신 에피소드 ${this.episodeNumber} 보기`
            break
          case 'begin' :
            display = `처음부터 보기`
            break
        }
        return display
      },
      getStreamButtonDisplay () {
        const { viewratio: viewRatio = '0' } = this.contentInfo
        const vodStatus = Number(viewRatio) > 0 ? 'continue' : this.contentStatus
        const movieStatus = Number(viewRatio) > 0 ? 'continue' : 'begin'
        const status = vodStatus || movieStatus

        return this.buttonDisplay(status)
      },
      getStreamButtonDisplayWavveOn () {
        const status = (this.contentType === 'movie') ? 'begin' : 'normal'
        return this.buttonDisplay(status)
      },
      getButtonName (title) {
        // landing info - content_status 가 comming soon 이면 view time 조회하지 않고 comming soon
        if (this.contentStatus === 'commingsoon') return this.buttonDisplay('commingsoon')
        // 구매 유도 버튼 판권 종료
        if (this.action === 'memo') return this.buttonDisplay('closed')
        // movie & movie 본편 없을 경우 '공개 예정'
        if (this.contentType === 'movie' && !this.hasMovieMainFilm) return this.buttonDisplay('commingsoon')

        return (this.action === 'stream')
          ? this.isWavveOn
            ? this.getStreamButtonDisplayWavveOn()
            : this.getStreamButtonDisplay()
          : title
      },
      async actionButtonSetting () {
        try {
          const data = await actionButtonStateInfoData(this.contentType, this.contentInfo)
          const { isVisible = true, title = '', action = '' } = data

          this.isLoading = isVisible
          this.action = action
          this.buttonName = this.getButtonName(title)
        } catch (err) {
          console.error(err, 'Button Info 를 가져올 수 없습니다.')
        }
      },
      init () {
        this.isLoading = true
        this.isButtonDisabled = false
        this.actionButtonSetting()
        this.episodeNumber = (this.contentInfo?.episodenumber || '').replace('회', '')
      }
    },
    created () {
      this.init()
    },
    watch: {
      contentInfo () {
        this.init()
      }
    }
  }
</script>
